import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Tree, Input} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Tree, {
        'draggable': true,
        'ev-dragend': this.onDragEnd,
        'allowDrag': this.allowDrag,
        'allowDrop': this.allowDrop,
        'ev-denydrag': this.onDenyDrag,
        'ev-denydrop': this.onDenyDrop,
        'ev-$model:data': function($v) {
            $this.set('data', $v);
        },
        'data': $this.get('data'),
        'ev-$model:expandedKeys': function($v) {
            $this.set('expandedKeys', $v);
        },
        'expandedKeys': $this.get('expandedKeys')
    });
};